import { Box } from '@mui/material'
import Head from 'next/head'
import { forwardRef } from 'react'
import { Fade } from 'utoniq-ui'

import { config } from '@/config'

type Props = {
  chromeless?: boolean
  type?: 'audio' | 'video'
}

/**
 * @description
 * THEOPlayerの再生UI
 * https://docs.theoplayer.com/getting-started/01-sdks/01-web/00-getting-started.md#theoplayer-css-library
 *
 * @param {boolean} chromeless 再生UIを表示しない場合はtrue
 */

export const TheoPlayerView = forwardRef<HTMLDivElement, Props>(
  ({ chromeless = false, type = 'audio' }: Props, ref) => {
    return (
      <>
        {!chromeless && (
          <Head>
            <link
              rel="stylesheet"
              type="text/css"
              href={`${config.theoPlayerLibraryLocation}/ui.css`}
            />
          </Head>
        )}
        <Box
          className={
            chromeless
              ? ''
              : 'theoplayer-container video-js theoplayer-skin vjs-16-9 THEOplayer'
          }
          ref={ref}
          sx={
            chromeless
              ? {
                  /**
                   * HACK: display: noneとするとSafariでの再生に失敗するため、CSSで非表示に見せている。
                   * また、透明度・サイズを設定しないと遷移時に画面キャプチャイベントが発火しないため、要素は完全に非表示にしていない。
                   */
                  padding: 0,
                  height: type === 'video' ? '100%' : '1px',
                  width: type === 'video' ? '100%' : '1px',
                  opacity: type === 'video' ? 1 : 0.01,
                  bgcolor: type === 'video' ? 'inherit' : 'background.default',
                  userSelect: 'none',
                  '& > *': {
                    visibility: 'visible',
                    pointerEvents: 'none',
                  },
                }
              : {}
          }
        />
      </>
    )
  }
)

// 動画を1枚の画像として表示する
export const TheoPlayerImageView = forwardRef<
  HTMLDivElement,
  Props & {
    playable: boolean
    isMagazine?: boolean
  }
>(({ playable, isMagazine }, ref) => {
  return (
    <>
      <Head>
        <link
          rel="stylesheet"
          type="text/css"
          href={`${config.theoPlayerLibraryLocation}/ui.css`}
        />
      </Head>
      <Fade>
        <Box
          sx={{
            display: 'grid',
            placeItems: 'center',
            // DRMマガジンの場合、シークバー分の高さを引く
            height: isMagazine ? 'calc(100dvh - 48px)' : '100dvh',
          }}
        >
          <Box
            ref={ref}
            sx={{
              width: '100%',
              height: 'auto',
              userSelect: 'none',
              '.theo-player-wrapper': {
                '& > *:not(.vjs-tech, .vjs-loading-spinner)': {
                  display: 'none!important',
                },
                '.vjs-tech': {
                  position: 'relative!important' as 'relative',
                  '& > *:not(video)': {
                    display: 'none',
                  },
                  video: {
                    display: playable ? 'block' : 'none!important',
                  },
                },
              },
            }}
          />
        </Box>
      </Fade>
    </>
  )
})
